// Renders a member's profile photo when one is set, otherwise falls back to the
// emoji avatar / name initial. Drop into the existing styled containers (which
// keep their size/ring/bg) — add `overflow-hidden` to the container so the photo
// clips to its rounded shape.
export default function Avatar({ url, fallback, name, imgClassName = 'w-full h-full object-cover' }) {
  if (url) {
    return <img src={url} alt={name ? `${name}'s photo` : 'Profile photo'} className={imgClassName} loading="lazy" />;
  }
  return <>{fallback || (name ? name[0] : '🧑')}</>;
}
